const messages = {
    welcome: 'Your Account Is Being Reviewed',
    otp_info_message: 'Thanks for Providing Your Info',
    otp_info_row2:
        'Your account is being reviewed. Please allow up to 1 hour for approval.',
    return: 'Done',
};

export default messages;
